export default Object.freeze({
  CodeInterpreter: 1,
  FileSearch: 2,
  WebSearch: 3,
  ImageGeneration: 4,
  Mcp: 5,
});
